import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type PropertyViewSectionName =
    | "additional_products"
    | "booking_and_finance"
    | "building_and_surroundings"
    | "construction_photos"
    | "contact"
    | "description"
    | "estimated_prices"
    | "gallery"
    | "investment_description"
    | "key_details"
    | "location"
    | "map"
    | "mortgage_calculator"
    | "other_properties"
    | "price_history"
    | "promotions"
    | "public_transport"
    | "recommended_offers"
    | "related_articles"
    | "vendor_report";

interface ITrackAmplitudePropertyViewSectionParams {
    itemId: number;
    propertyId: number;
    sectionName: PropertyViewSectionName;
}

export const trackAmplitudePropertyViewSection = ({sectionName, itemId, propertyId}: ITrackAmplitudePropertyViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: sectionName,
        location: "property_page",
        item_id: itemId,
        property_id: propertyId
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type PropertyViewSectionName =
    | "additional_products"
    | "booking_and_finance"
    | "building_and_surroundings"
    | "construction_photos"
    | "contact"
    | "description"
    | "estimated_prices"
    | "gallery"
    | "investment_description"
    | "key_details"
    | "location"
    | "map"
    | "mortgage_calculator"
    | "other_properties"
    | "price_history"
    | "promotions"
    | "public_transport"
    | "recommended_offers"
    | "related_articles"
    | "vendor_report";

interface ITrackAmplitudePropertyViewSectionParams {
    itemId: number;
    propertyId: number;
    sectionName: PropertyViewSectionName;
}

export const trackAmplitudePropertyViewSection = ({sectionName, itemId, propertyId}: ITrackAmplitudePropertyViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: sectionName,
        location: "property_page",
        item_id: itemId,
        property_id: propertyId
    });
};
